export const colors = ["#2f3542", "#57606f"];
